import InsuranceNo from '../../../common/icons/InsuranceNo';
import InsuranceYes from '../../../common/icons/InsuranceYes';

export const SUBSTEPS = {
  HAS_SOCIAL_ASSISTANCE: 'socialAssistance',
  ALT_PAYMENT_PLANS: 'altPaymentPlans',
  DETAILS: 'details',
  NOT_ELIGIBLE: 'notEligible',
  US_PLANS: 'usPlans',
};

export const SUB_ROUTES = {
  [SUBSTEPS.DETAILS]: {
    path: 'details',
  },
  [SUBSTEPS.HAS_SOCIAL_ASSISTANCE]: {
    path: 'social-assistance',
  },
  [SUBSTEPS.ALT_PAYMENT_PLANS]: {
    path: 'alt-payment-plans',
  },
  [SUBSTEPS.NOT_ELIGIBLE]: {
    path: 'not-eligible',
  },
  [SUBSTEPS.PLANS]: {
    path: 'details-plan',
  },
};

export const hasInsuranceOptions = [
  {
    id: 'Yes',
    title: 'Yes',
    description: 'I have insurance',
    data: true,
    icon: InsuranceYes,
  },
  {
    id: 'No',
    title: 'No',
    description: "I don't have insurance",
    data: false,
    icon: InsuranceNo,
  },
];
